export const cleanString = (input = "", replace = "") => {
  const normalized = input.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return normalized.replace(/[^a-zA-Z0-9]/g, replace);
};

export const justNumbers = (str) => {
  return str.replace(/[^0-9]/g, "");
};
